import { useEffect, useRef } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { SMART_LOOK_ALLOWED_PATHS } from 'consts/paths';

const initSmartlookVariable = () => {
  /* eslint-disable */
  window.smartlook ||
    (function (d) {
      var o = (window.smartlook = function () {
          o.api.push(arguments);
        }),
        h = d.getElementsByTagName('head')[0];
      var c = d.createElement('script');
      o.api = new Array();
      c.async = true;
      c.type = 'text/javascript';
      c.charset = 'utf-8';
      c.src = 'https://web-sdk.smartlook.com/recorder.js';
      h.appendChild(c);
    })(document);
  /* eslint-enable */
};

const useSmartLook = () => {
  const { pathname } = useLocation();
  const isInited = useRef(false);

  useEffect(() => {
    if (!process.env.REACT_APP_SMARTLOOK_API_KEY) return;

    const allowedPath = SMART_LOOK_ALLOWED_PATHS.some(path =>
      matchPath(pathname, { path, exact: true, strict: false }),
    );

    if (!isInited.current && allowedPath) {
      isInited.current = true;
      initSmartlookVariable();
      window.smartlook('init', process.env.REACT_APP_SMARTLOOK_API_KEY, { region: 'eu' });

      return;
    }

    if (isInited.current) {
      window.smartlook('disable', !allowedPath);
    }
  }, [pathname]);
};

export default useSmartLook;
